// extracted by mini-css-extract-plugin
export default {"renderItem":"item-assignment-styles_renderItem__KfpfF"};